import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { Amplify } from 'aws-amplify';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// Configure Cognito for OPTIONAL sign-in. The same user pool as the portal is used, so a user already
// signed into the portal gets a near-seamless hosted-UI SSO. Local env has no Cognito config (anonymous
// browsing only), so we guard on the presence of the config fields. Mirrors ee-portal's configure call.
const env = environment as Record<string, any>;
if (env['cognito_domain'] && env['cognito_clientid']) {
  Amplify.configure({
    version: '1.4',
    auth: {
      user_pool_id: env['cognito_domain'].split('/').pop(),
      user_pool_client_id: env['cognito_clientid'],
      oauth: {
        redirect_sign_in_uri: [env['base_url'] + '/callback'],
        redirect_sign_out_uri: [env['base_url'] + '/'],
        response_type: 'code',
        scopes: ['aws.cognito.signin.user.admin', 'email', 'openid', 'phone', 'profile'],
        domain: env['cognito_custom_domain'],
      },
    },
  });
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));
